import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { ECLService } from '@lmc-app/core/services/ecl.service';

@Component({
	selector: 'app-loan-staging',
	templateUrl: './loan-staging.component.html',
	styleUrls: ['./loan-staging.component.scss'],
})
export class LoanStagingComponent implements OnInit, OnDestroy {
	private parentSub = new Subscription();
	private readonly _onDestroy = new Subject<void>();

	protected isLoading: boolean = false;
	protected readonly inputDateForm = new FormGroup({
		input_date: new FormControl(null),
	});

	protected balance = {
		"stage1": {
			"low": 0,
			"normal": 0,
			"total": 0,
		},
		"stage2": {
			"normal": 0,
			"high": 0,
			"total": 0,
		},
		"stage3": {
			"normal": 0,
			"high": 0,
			"total": 0,
		},
		"low": 0,
		"normal": 0,
		"high": 0,
		"total": 0,
	};

	protected eclBalance = {
		"stage1": {
			"low": 0,
			"normal": 0,
			"total": 0,
		},
		"stage2": {
			"normal": 0,
			"high": 0,
			"total": 0,
		},
		"stage3": {
			"normal": 0,
			"high": 0,
			"total": 0,
		},
		"low": 0,
		"normal": 0,
		"high": 0,
		"total": 0,
	};

	protected readonly title: string = "Loan Staging";

	public constructor(
		private eclService: ECLService,
		protected readonly currencyFormatter: CurrencyPipe,
	) { }

	public ngOnInit(): void {
		this.inputDateForm.controls.input_date.setValue(new Date("2026-01-01"));
	}

	public ngOnDestroy(): void {
		this.parentSub.unsubscribe();
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	protected getBalance() {
		const inputDate = this.inputDateForm.controls.input_date.value.toISOString().substring(0, 10);
		this.isLoading = true;
		this.parentSub.add(this.eclService.getLoanStaging(inputDate).subscribe((res: any) => {
			this.isLoading = false;
			if (res) {
				this.balance = res.balance;
				this.balance.stage1.total = this.balance.stage1.low + this.balance.stage1.normal;
				this.balance.stage2.total = this.balance.stage2.normal + this.balance.stage2.high;
				this.balance.stage3.total = this.balance.stage3.normal + this.balance.stage3.high;
				this.balance.low = this.balance.stage1.low;
				this.balance.normal = this.balance.stage1.normal + this.balance.stage2.normal + this.balance.stage3.normal;
				this.balance.high = this.balance.stage2.high + this.balance.stage3.high;
				this.balance.total = this.balance.stage1.total + this.balance.stage2.total + this.balance.stage3.total;

				this.eclBalance = res.eclBalance;
				this.eclBalance.stage1.total = this.eclBalance.stage1.low + this.eclBalance.stage1.normal;
				this.eclBalance.stage2.total = this.eclBalance.stage2.normal + this.eclBalance.stage2.high;
				this.eclBalance.stage3.total = this.eclBalance.stage3.normal + this.eclBalance.stage3.high;
				this.eclBalance.low = this.eclBalance.stage1.low;
				this.eclBalance.normal = this.eclBalance.stage1.normal + this.eclBalance.stage2.normal + this.eclBalance.stage3.normal;
				this.eclBalance.high = this.eclBalance.stage2.high + this.eclBalance.stage3.high;
				this.eclBalance.total = this.eclBalance.stage1.total + this.eclBalance.stage2.total + this.eclBalance.stage3.total;
			}
		}));
	}
}
